import {
  GET_ALL_INVOICES,
  GET_INVOICES_WITH_ID,
  UPDATE_INVOICES,
  CREATE_INVOICES,
  GET_INVOICES_LOGS,
  GET_INVOICES_FILE
} from './constants';
// import { Payload, cancelPayload } from './interfaces';

export function getInvoicesAction(payload: Object) {
  return {
    type: GET_ALL_INVOICES,
    payload,
  };
}

export function getInvoiceWithIdAction(payload: Object) {
  return {
    type: GET_INVOICES_WITH_ID,
    payload,
  };
}

export function getInvoiceFileAction(payload: Object) {
  return {
    type: GET_INVOICES_FILE,
    payload,
  };
}

export function updateInvoiceActions(payload: { id: number }) {
  return {
    type: UPDATE_INVOICES,
    payload,
  };
}

export function createInvoiceActions(payload: Payload) {
  return {
    type: CREATE_INVOICES,
    payload,
  };
}

export function getInvoicesLogs(payload: cancelPayload) {
  return {
    type: GET_INVOICES_LOGS,
    payload,
  };
}
